/**
 * Only follow post-login redirects to paths on this site.
 *
 * `?redirect=` comes from the URL, so without this a link like
 * /login?redirect=//evil.example sends a freshly signed-in user off-site
 * (react-router treats `//host` and `/\host` as other origins).
 */
export function safeRedirectPath(path, fallback = '/profile') {
  if (typeof path !== 'string') return fallback;
  const trimmed = path.trim();
  if (!trimmed.startsWith('/')) return fallback;
  if (trimmed.startsWith('//') || trimmed.includes('\\')) return fallback;
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f]/.test(trimmed)) return fallback;
  return trimmed;
}
